<ion-app>

  <div class="safe-area-cover"></div>

  <!-- Root content container -->
  <ion-content>
    <!-- Primary router outlet for page navigation -->
    <ion-router-outlet [swipeGesture]="swipeGestureEnabled"></ion-router-outlet>

    <!-- Overlay popup menu shown for logged-in users -->
    @if (showPopup && isLoggedIn()) {
    <div class="form-popup" slot="fixed">
      <ion-grid class="h-100 p-0">
        <ion-row class="g-2">
          <!-- Dynamic popup menu items -->
          @for (tab of menuTabs(); track tab) {
          <ion-col class="menu-col" size="4">
            <button class="menuicon w-100 h-100 d-flex flex-column align-items-center justify-content-center p-0"
              [ngClass]="storedmenuId === tab.id ? 'activemenu' : 'deactivemenu'"
              (click)="selectmenuclose(tab.sequence, tab.url, tab.id)"
              (keydown.enter)="selectmenuclose(tab.sequence, tab.url, tab.id)">
              <ion-icon class="iconSize mb-1" [src]="tab.icon">
              </ion-icon>

              <span class="fontsize text-center">
                {{ tab.name }}
              </span>
            </button>
          </ion-col>
          }

          <!-- Logout action inside popup menu -->
          <ion-col class="menu-col" size="4">
            <button
              class="bg-transparent primary-color w-100 h-100 d-flex flex-column align-items-center justify-content-center p-0 menuicon"
              (click)="logout()" (keydown.enter)="logout()">
              <ion-icon class="iconSize mb-1" src="assets/imgs/logout-icon.svg">
              </ion-icon>

              <span class="fontsize text-center">
                Logout
              </span>
            </button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    }
  </ion-content>

  <!-- Persistent bottom navigation for logged-in users -->
  @if (isLoggedIn() && showMobileMenu()) {
  <ion-footer class="mobile-bottom-menu">
    <ion-toolbar>
      <div class="d-flex align-items-center justify-content-around py-1">
        <!-- Static bottom menu items -->
        @for (staticTabs of staticMenuItems(); track $index) {
        <button class="bottom-menu-btn d-flex flex-column align-items-center p-0 position-relative"
          type="button"
          [disabled]="menuDisabled()"
          [attr.aria-disabled]="menuDisabled() ? 'true' : 'false'"
          [attr.tabindex]="menuDisabled() ? -1 : 0"
          [ngClass]="[storedmenuId === staticTabs.id ? 'activemenu' : 'deactivemenu', menuDisabled() ? 'menu-item-disabled' : '']"
          (click)="naviagteTab(staticTabs.id,staticTabs.sequence, staticTabs.url)"
          (keydown.enter)="naviagteTab(staticTabs.id,staticTabs.sequence, staticTabs.url)">
          <!-- Icon rendering based on tab sequence -->
          @if (parseNumber(staticTabs.sequence) < 2) { <ion-icon class="svgIcon" [src]="staticTabs.icon">
            </ion-icon>
            }
            @else if (parseNumber(staticTabs.sequence) === 2) {
              <ion-icon class="svgIconNotification" [src]="staticTabs.icon">
              </ion-icon>
              <span class="noti-count">
                {{ unreadCount() }}
              </span>
            }
            @else {
            <ion-icon class="svgIconNotification" [src]="staticTabs.icon">
            </ion-icon>
            }

            <!-- Bottom menu label -->
            <span class="menu-label mt-1 text-center">
              {{ staticTabs.name }}
            </span>
        </button>
        }
      </div>
    </ion-toolbar>
  </ion-footer>
  }
</ion-app>
